var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarTotalBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1912 7.37927H5.0355C4.62075 7.37927 4.2855 7.04327 4.2855 6.62927C4.2855 6.21527 4.62075 5.87927 5.0355 5.87927H18.2145V3.06677C18.2145 2.66702 18.0352 2.29427 17.7233 2.04452C17.4097 1.79327 17.004 1.70252 16.617 1.78952L2.5215 4.95452C1.92075 5.08952 1.5 5.61527 1.5 6.23177V20.934C1.5 21.6555 2.08725 22.2435 2.80875 22.2435H21.1912C21.9128 22.2435 22.5 21.6563 22.5 20.934V8.68802C22.5 7.96652 21.9128 7.37927 21.1912 7.37927ZM18.8295 16.1483C18.1283 16.1483 17.5583 15.5775 17.5583 14.8763C17.5583 14.175 18.129 13.6043 18.8295 13.6043C19.5315 13.6043 20.1015 14.175 20.1015 14.8763C20.1015 15.5775 19.5315 16.1483 18.8295 16.1483Z",
    fill: "#FF8400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTotalBalance);
export default __webpack_public_path__ + "static/media/sidebar-total-balance.14efdbc1a2f43b0f825e11a7430a9475.svg";
export { ForwardRef as ReactComponent };